import { GPXOptions } from "leaflet";

export const options: GPXOptions = {
  async: true,
  // polyline_options: {
  //   color: 'green',
  //   opacity: 0.5,
  //   weight: 7,
  //   lineCap: 'round'
  // },
  marker_options: {
    startIcon: undefined,
    endIcon: undefined,
    startIconUrl: undefined,
    endIconUrl: undefined
  },
  gpx_options: {
    parseElements: ['track', 'route', 'waypoint']
  }
};
